export default {
  title: 'Join {{name}}!',
  default_program_name: 'Rewards Club',
  savings_highlight: {
    title: 'Get rewarded. Every order, every time.',
    subtitle: 'Sign up in seconds and start earning points.',
  },
  how_it_works: {
    label: 'How it works',
    step_1: {
      title: 'Sign up in 30s',
      desc: 'Just your phone number',
    },
    step_2: {
      title: 'Order & earn',
      desc: '{{percentage}}% back on every order',
    },
    step_3: {
      title: 'Redeem & save',
      desc: 'Up to {{amount}} off per order',
    },
  },
  profile: {
    verified_title: 'Phone verified!',
    verified_subtitle: 'Complete your profile to start earning.',
  },
  form: {
    phone_number: {
      label: 'Phone number',
      description: "We'll send a verification code to confirm it's you.",
      placeholder: 'Phone number',
    },
    birthday: {
      label: 'Birthday — day and month is enough to get a gift 🥳',
      placeholder: 'Birthday (optional)',
      parts: {
        month: 'Month',
        day: 'Day',
      },
    },
  },
  terms:
    'By signing up, you agree to our <TermsLink>terms & conditions</TermsLink> and consent to our <PrivacyPolicyLink>privacy policy</PrivacyPolicyLink>.',
  buttons: {
    continue: 'Continue',
    verify: 'Verify',
    complete: 'Complete signup',
  },
  toasts: {
    login_success: 'You have been successfully logged in',
    invalid_code: 'Invalid code. Please try again.',
    failed_to_update_profile: 'Failed to update profile. Please try again.',
  },
};
